import { environment } from '../environments/environment';

const config = {
  endpoint: 'http://localhost:3000/api',
  ...environment,
};
export default config;
